import { render } from "./HowtovoteSimp.vue?vue&type=template&id=63ad146e&scoped=true"
import script from "./HowtovoteSimp.vue?vue&type=script&lang=js"
export * from "./HowtovoteSimp.vue?vue&type=script&lang=js"

import "./HowtovoteSimp.vue?vue&type=style&index=0&id=63ad146e&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ad146e"]])

export default __exports__